module.exports = __webpack_public_path__ + "img/magic-soul.36689c89.png";